import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 offset-md-3" }

import { useStore } from 'vuex';

import {RootState} from "@/store";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ComponentsAuthRegisterSuccess',
},
  __name: 'RegisterSuccess',
  emits: ["resubscribePage", "switchMode"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore<RootState>();

const handleClickActionRegisterFinish = () => {
  store.dispatch('auth/setWelcomeScreen', false); // TODO: Store it in the localStorage
  emit('switchMode', 'login');
  emit('resubscribePage');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "login-form mt-4 p-4" }, [
      _createElementVNode("div", { class: "row g-3" }, [
        _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Регистрация успешно завершена", -1)),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-dark float-end ms-3",
            onClick: handleClickActionRegisterFinish
          }, "Продолжить")
        ])
      ])
    ])
  ]))
}
}

})